import React, { useState } from "react";
import { useDndContext, useDroppable } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import Cards from "./Cards";
import _ from "underscore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const KanbanColumn = React.memo(({ status, title, tasks, option, isDisabled, handleChange, setShowPopup, selectedTaskIds, setSelectedTaskIds }) => {
    const { setNodeRef, isOver } = useDroppable({
        id: status,
    });
    const { over } = useDndContext()
    const itemIdsInColumn = tasks?.map(item => item.id);
    const active = itemIdsInColumn.includes(over?.id) || isOver;
    const [expanded, setExpanded] = useState(true);

    const style = {
        backgroundColor: "#ffff",
        borderRadius: 8,
        width: "100%",
        flex: 1,
        transition: "background 0.2s, box-shadow 0.2s, border 0.2s",
        border: active && !isDisabled ? "2px solid #1976d2" : "2px solid #e0e0e0",
        boxShadow: active && !isDisabled ? "0 0 8px #1976d2" : "0 2px 4px rgba(0, 0, 0, 0.03)",
        position: "relative",
        opacity: isDisabled ? 0.5 : 1,
        pointerEvents: isDisabled ? "none" : "auto",
    };

    return (
        <div ref={setNodeRef} style={style}>
            <div className='status-name c-pointer' onClick={() => setExpanded(!expanded)}>
                <header className='text-center'>
                    <FontAwesomeIcon icon={`fa-solid ${expanded ? " fa-angle-down" : " fa-angle-right"}`} />
                    <span> {title} ( {tasks?.length} )</span></header>
            </div>

            {
                expanded && <SortableContext items={_.pluck(_.filter(tasks, t => t.id), 'id')} strategy={verticalListSortingStrategy}>
                    {tasks.length === 0 && (
                        <div className='drop-card'>
                            Drop here
                        </div>
                    )}
                    <div className=" d-flex flex-wrap align-items-stretch mt-2">
                        {tasks.map((task) => (
                            <Cards id={task.id} status={status} task={task} key={task.id} option={option} handleChange={handleChange} setShowPopup={setShowPopup} selectedTaskIds={selectedTaskIds} setSelectedTaskIds={setSelectedTaskIds} />
                        ))}
                    </div>
                </SortableContext>
            }

        </div>
    );
})
export default KanbanColumn;